import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 11,
  path: '/dataV',
  component: Home,
  redirect: '/dataV/index',
  name: 'dataV',
  isHead: true,
  meta: {
    title: '数据大屏',
    icon: 'el-icon-s-platform'
  }
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/dataV.js